export const PERMISSIONS_OPTIONS = [
  {
    name: "Discount Codes",
    value: "discounts",
  },
  {
    name: "Analytics",
    value: "analytics",
  },
  {
    name: "Labs",
    value: "labs",
  },
  {
    name: "Clients",
    value: "clients",
  },
  {
    name: "Categories",
    value: "categories",
  },
  {
    name: "Users",
    value: "users",
  },
  {
    name: "Docs",
    value: "docs",
  },
]

export const DEFAULT_PERMISSIONS = [
  "discounts",
  "analytics",
  "labs",
  "clients",
  "categories",
  "users",
  "seo",
  "docs",
]

export const PERMISSION_GROUPS = ["super", "admin", "read-only"]
